import { render, staticRenderFns } from "./Dashboard-Intro.vue?vue&type=template&id=13f98f1c&scoped=true"
import script from "./Dashboard-Intro.vue?vue&type=script&lang=js"
export * from "./Dashboard-Intro.vue?vue&type=script&lang=js"
import style0 from "./Dashboard-Intro.vue?vue&type=style&index=0&id=13f98f1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f98f1c",
  null
  
)

export default component.exports